import { AudioMix } from "./audio-mix";
import { PlatformLanguageCode } from "./platform-language-code";
import { FrameRateAssetAssociation } from "./frame-rate-asset-association";

export class AudioMixLanguageCouple {
  id: number | null = 0;
  mixEnum: AudioMix | null = null;
  language: PlatformLanguageCode | null = null;
  isMusicAndEffects: boolean = false;
  isAudioDescription: boolean = false;
  isCommentary: boolean = false;
  isAvailable: boolean = false;
  isOriginalVersion: boolean = false;
  contentType: string | null = null;
  contentId: number | null = 0;
  isMuted: boolean = false;
  concernedAssetIds: number[] | null = [];
  concernedAssetIdsByFps: FrameRateAssetAssociation[] | null = [];

  constructor(init?: Partial<AudioMixLanguageCouple>) {
    Object.assign(this, init);
  }
}
